<app-menu-bar></app-menu-bar>

<div class="gateways-page">
    <div class="gateways-container">
        <!-- The nav branches by role itself (admin tabs / Files / Gateways),
             so every portal page renders it — same as /account and /my-files. -->
        <app-admin-nav></app-admin-nav>

        @if (!isAdmin) {
            <h1 class="title">My Gateways</h1>
        }

        @if (loading) {
            <div class="loading-state">
                <span class="spinner" role="status" aria-label="Loading gateways"></span>
            </div>
        } @else if (isAdmin) {
            <!-- ============ ADMIN TABLE VIEW ============ -->
            <div class="admin-toolbar">
                <input class="search" type="text" placeholder="Search gateways" autocomplete="off" [(ngModel)]="search" />
                <button class="add-btn" type="button" (click)="openProvisionModal()">Add new gateway</button>
            </div>

            @if (filteredGateways.length === 0) {
                <p class="state-text">No gateways found.</p>
            } @else {
                <div class="table-wrap">
                    <table class="gw-table">
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>UID</th>
                                <th>Activate key</th>
                                <th>Date activated</th>
                                <th class="center">Connected</th>
                                <th class="center">Active</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (gw of filteredGateways; track gw.id) {
                                <tr>
                                    <td>{{ gw.descr }}</td>
                                    <td class="uid">{{ formatUid(gw.uid) }}</td>
                                    <td>{{ gw.code }}</td>
                                    <td>{{ formatDate(gw.activationDate) }}</td>
                                    <td class="center">
                                        @if (gw.isConnected === 1) {
                                            <fa-icon [icon]="faCircleCheck" class="conn connected" title="Connected"></fa-icon>
                                        } @else {
                                            <fa-icon [icon]="faCircleExclamation" class="conn disconnected" title="Not connected"></fa-icon>
                                        }
                                    </td>
                                    <td class="center">
                                        <input type="checkbox" [checked]="gw.active === 1" (change)="toggleActive(gw, $event)" />
                                    </td>
                                    <td class="center">
                                        <div ngbDropdown container="body" class="tools-dropdown">
                                            <button class="tools-btn" type="button" ngbDropdownToggle>Tools</button>
                                            <div ngbDropdownMenu class="gw-tools-menu">
                                                <button ngbDropdownItem (click)="deletePermanent(gw)">Delete</button>
                                                <button ngbDropdownItem (click)="empty(gw)">Empty</button>
                                                <button ngbDropdownItem (click)="openTool('replace', gw)">Replace</button>
                                                <button ngbDropdownItem (click)="openTool('username', gw)">Change username</button>
                                                <button ngbDropdownItem (click)="openTool('password', gw)">Change password</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        } @else {
            <!-- ============ CUSTOMER CARD VIEW ============ -->
            @if (gateways.length === 0) {
                <p class="state-text">You have no gateways yet.</p>
            } @else {
                <div class="gateways-grid">
                    @for (gw of gateways; track gw.id) {
                        <div class="gateway-card">
                            <div class="row">
                                <span class="label">UID</span>
                                <span class="value">{{ gw.uid }}</span>
                            </div>
                            <div class="row">
                                <span class="label">Code</span>
                                <span class="value">{{ gw.descr }}</span>
                            </div>
                            <div class="row">
                                <span class="label">Status</span>
                                <div class="actions">
                                    @if (gw.active !== 0) {
                                        @if (gw.isConnected === 1) {
                                            <a class="pill connected" [href]="gw.connectUrl" target="_blank" rel="noopener">Show Gateway</a>
                                        } @else {
                                            <a class="pill disconnected" [href]="gw.connectUrl" target="_blank" rel="noopener">Not connected</a>
                                        }
                                        <form ngNoForm class="spy-form" [attr.action]="spyUrl" method="post" target="_blank" rel="noopener">
                                            <input type="hidden" name="db" [value]="gw.database || ''" />
                                            <button type="submit" class="pill spy">Open SPY</button>
                                        </form>
                                    } @else {
                                        <span class="pill inactive">Inactive</span>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            <div class="add-gateway">
                <h2 class="add-gateway__title">Add new gateway</h2>
                <form class="add-gateway__form" (ngSubmit)="activate()">
                    <label for="activationCode">Activation code</label>
                    <input id="activationCode" type="text" name="activationCode"
                        [(ngModel)]="newActivationCode" autocomplete="off" />
                    <button type="submit" [disabled]="activating || !newActivationCode.trim()">
                        Activate
                    </button>
                </form>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
